module.exports = __webpack_public_path__ + "json/buildings-13.json?0a0badc2071ca2c0dd0bb132bc4c7f5b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-13.json
// module id = 1719
// module chunks = 3